// extracted by mini-css-extract-plugin
module.exports = {"GoogleDriveVideoPlayer":"GoogleDriveVideoPlayer_GoogleDriveVideoPlayer__1gYi3","GoogleDriveVideoPlayer__iframe":"GoogleDriveVideoPlayer_GoogleDriveVideoPlayer__iframe__2axjJ"};